import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
  export default {
    components: {
    },
    data() {
      return {
        ShowLoader: false,
        RoleData: "",
        UserId:0,
        RoleHeading:"",
        Permissions:""
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + ' - User Permissions';
      this.UserId = this.$route.params.UserId;
      this.GetRoles();
    },
    methods: {
      GetRoles() {
        Axios.post(Endpoints.Roles.Permission,  {
          token: localStorage.getItem("token"),
          id: this.UserId,
        }).then((Response) => {
          if (Response?.data?.success) {
            this.RoleData = Response.data.record;
            if(this.RoleData.role){
              this.RoleHeading = this.RoleData.role.title;
              this.Permissions = this.RoleData.role.permissions;
            }
          }
        });
      },
    },
  };